export default __webpack_public_path__ + "static/media/videotp.afbf15a2.jpg";